"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Industries_1 = __importDefault(require("./FacetParts/Industries"));
const Heights_1 = __importDefault(require("./FacetParts/Heights"));
const Widths_1 = __importDefault(require("./FacetParts/Widths"));
const Tags_1 = __importDefault(require("./FacetParts/Tags"));
const ContentTypes_1 = __importDefault(require("./FacetParts/ContentTypes"));
const Placements_1 = __importDefault(require("./FacetParts/Placements"));
const AspectRatios_1 = __importDefault(require("./FacetParts/AspectRatios"));
const Compositions_1 = __importDefault(require("./FacetParts/Compositions"));
const OrganizationTag_1 = __importDefault(require("./FacetParts/OrganizationTag"));
/**
 * Creative Search用のFacets。
 *
 * @desc constructorをprivateにしているため、fromJSONからのみinstance化が可能。
 *
 * @example <caption>fromJSONからinstance化</caption>
 * ResultFacets.fromJSON({...})
 *
 * @example <caption>new からはできない。</caption>
 * new ResultFacets({...}) // instance化できない
 */
class ResultFacets {
    /**
     * Static Factory Method 以外から作れないようにprivateにしている。
     * @param param0 IResultFacetsのJSON
     */
    constructor({ industry, height, width, tag, contentType, scope, placement, aspectRatio, composition, organizationTag, }) {
        this.industry = industry;
        this.height = height;
        this.width = width;
        this.tag = tag;
        this.contentType = contentType;
        this.scope = scope;
        this.placement = placement;
        this.aspectRatio = aspectRatio;
        this.composition = composition;
        this.organizationTag = organizationTag;
    }
}
exports.ResultFacets = ResultFacets;
/**
 * Entityを作るStatic Factory Method.
 */
ResultFacets.fromJSON = (facets) => {
    const { industry, height, width, tag, contentType, scope, placement, aspectRatio, composition, organizationTag, } = Object.assign({}, facets);
    const _industry = Industries_1.default.fromJSON(industry);
    const _height = Heights_1.default.fromJSON(height);
    const _width = Widths_1.default.fromJSON(width);
    const _tag = Tags_1.default.fromJSON(tag);
    const _contentType = ContentTypes_1.default.fromJSON(contentType);
    const _scope = ContentTypes_1.default.fromJSON(scope);
    const _placement = Placements_1.default.fromJSON(placement);
    const _aspectRatio = AspectRatios_1.default.fromJSON(aspectRatio);
    const _composition = Compositions_1.default.fromJSON(composition);
    const _organizationTag = OrganizationTag_1.default.fromJSON(organizationTag);
    return new ResultFacets({
        industry: _industry,
        height: _height,
        width: _width,
        tag: _tag,
        contentType: _contentType,
        scope: _scope,
        placement: _placement,
        aspectRatio: _aspectRatio,
        composition: _composition,
        organizationTag: _organizationTag,
    });
};
/**
 * Director Web用のFacets.
 *
 * 注意: 単数形と複数形が合っていないので使うときは意識する事。（例）organizationTagなのに複数形
 *
 * @desc constructorをprivateにしているため、fromJSONからのみinstance化が可能。
 *
 * @example <caption>fromJSONからinstance化</caption>
 * ResultFacets.fromJSON({...})
 *
 * @example <caption>new からはできない。</caption>
 * new ResultFacets({...}) // instance化できない
 */
class AllFacets {
    /**
     * Static Factory Method 以外から作れないようにprivateにしている。
     * @param param0 AllFacetsTypeのJSON
     */
    constructor({ industry, placement, aspectRatio, composition, organizationTag }) {
        this.industry = industry;
        this.placement = placement;
        this.aspectRatio = aspectRatio;
        this.composition = composition;
        this.organizationTag = organizationTag;
    }
}
exports.AllFacets = AllFacets;
/**
 * Entityを作るStatic Factory Method.
 */
AllFacets.fromJSON = (facets) => {
    const { industry, placement, aspectRatio, composition, organizationTag } = Object.assign({}, facets);
    const _industry = Industries_1.default.fromJSON(industry);
    const _placement = Placements_1.default.fromJSON(placement);
    const _aspectRatio = AspectRatios_1.default.fromJSON(aspectRatio);
    const _composition = Compositions_1.default.fromJSON(composition);
    const _organizationTag = OrganizationTag_1.default.fromJSON(organizationTag);
    return new AllFacets({
        industry: _industry,
        placement: _placement,
        aspectRatio: _aspectRatio,
        composition: _composition,
        organizationTag: _organizationTag,
    });
};
